import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Icon from '../Icon';

// technically all we really need is to set the props to 
// "React.ComponentPropsWithoutRef<typeof Svg>", but in order for our custom
// props to come through in Storybook we need to bring them up again here 

export default function AddIcon(_ref) {
  let {
    contextType = 'image',
    className = '',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 40 40"
  }, props, {
    contextType: contextType,
    className: `pi pi-add-icon ${className}`
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0zm9.09 21.4c0 .9-.73 1.63-1.63 1.63h-4.43v4.43c0 .9-.73 1.63-1.63 1.63h-2.8c-.9 0-1.63-.73-1.63-1.63v-4.43h-4.43c-.9 0-1.63-.73-1.63-1.63v-2.8c0-.9.73-1.63 1.63-1.63h4.43v-4.43c0-.9.73-1.63 1.63-1.63h2.79c.9 0 1.63.73 1.63 1.63v4.43h4.43c.9 0 1.63.73 1.63 1.63v2.8z"
  })));
}